import React, { useEffect, useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { LocationsSelectInput, EquipmentsSelectInput, Select, FiltersContainer, Txt, Menu, Icon } from '../../../../components'
import { validateFilters } from '../../helpers'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import { fromOptions, radiusOptions } from '../../../../utils/Values/FiltersTypes'
import notificationActions from '../../../../redux/notifications/notificationActions'
import { filtersStyles as styles } from '../../../../components/FiltersContainer/styles'
import { useTheme } from '../../../../theming/ThemeProvider'
import Identity from '../../../../utils/Identity'

const Filters = ({
  initialValues, modalRef, onClose, handleSearch, handleClearFilters, handleSearchOrderNumber
}) => {
  const { isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const dispatch = useDispatch()

  const [filters, setFilters] = useState(initialValues)

  useEffect(() => {
    setFilters(initialValues)
  }, [initialValues])

  const handleSetFilters = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }))
  }

  const handleOnPress = () => {
    const { error, message, notApply } = validateFilters(filters)
    if (notApply) return
    if (error) return dispatch(notificationActions.SendToast({ message, type: 'error' }))
    handleSearch(filters)
    onClose()
  }

  return (
    <FiltersContainer
      modalRef={modalRef}
      onClose={onClose}
      handleSearch={handleOnPress}
      handleClearFilters={handleClearFilters}
      initOrderNumber={initialValues.movementNumber}
      orderNumberFilter
      handleSearchOrderNumber={handleSearchOrderNumber}
    >
      <View style={[isDesktop && styles.inputsContainer]}>
        <View style={styles.input}>
          <LocationsSelectInput
            name='originLocations'
            placeholder='Origin'
            origin
            multiselect
            selected={filters.originLocations}
            onChange={handleSetFilters}
          />
        </View>
        <View style={[styles.input, isDesktop && { marginHorizontal: 15 }]}>
          <LocationsSelectInput
            name='destinationLocations'
            placeholder='Destination'
            multiselect
            selected={filters.destinationLocations}
            onChange={handleSetFilters}
          />
        </View>
        <View style={[styles.input, isDesktop && { marginRight: 15 }]}>
          <EquipmentsSelectInput
            name='equipmentsTypes'
            multiselect
            selected={filters.equipmentsTypes}
            onChange={handleSetFilters}
          />
        </View>
        {!isDesktop && (
          <Txt
            text='Distance radius'
            identity='body2Bold'
          />
        )}
        {!isDesktop && (
          <View style={[styles.input, isDesktop && { marginRight: 15 }]}>
            <Select
              name='from'
              selected={filters.from}
              onChange={handleSetFilters}
              placeholder='From'
              keyProp='value'
              nameProp='label'
              options={fromOptions}
            />
          </View>
        )}
        <View style={[styles.input, isDesktop && { marginRight: 15 }]}>
          {isDesktop && (
            <View style={loadsFiltersStyles.fromFilter}>
              <Menu
                items={fromOptions.map(option => ({
                  text: option.label,
                  fn: () => handleSetFilters('from', option)
                }))}
                itemStyle={loadsFiltersStyles.fromFilterItem}
                textStyle={Identity.Font(isDesktop).body3}
              >
                <View style={loadsFiltersStyles.fromOption}>
                  <Txt
                    text={`from: ${filters.from?.label || '- -'}`}
                    identity='body3Bold'
                  />
                  <Icon
                    name='AngleDown'
                    width={15}
                    height={15}
                    style={loadsFiltersStyles.fromIcon}
                    fill={theme.BUNKER}
                  />
                </View>
              </Menu>
            </View>
          )}
          <Select
            name='radius'
            selected={filters.radius}
            onChange={handleSetFilters}
            placeholder='Radius'
            keyProp='label'
            nameProp='value'
            options={radiusOptions}
          />
        </View>
      </View>
    </FiltersContainer>
  )
}

const loadsFiltersStyles = StyleSheet.create({
  fromFilter: {
    position: 'absolute',
    top: -20
  },
  fromOption: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  fromIcon: {
    marginLeft: 5
  },
  fromFilterItem: {
    height: 30
  }
})

Filters.propTypes = {
  initialValues: PropTypes.object.isRequired,
  modalRef: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  handleSearchOrderNumber: PropTypes.func.isRequired
}

export default Filters
